export const common = {
  nav: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    doctors: 'Doctors',
    contact: 'Contact',
    appointment: 'Book Appointment'
  },
  hero: {
    title: 'Modern Dentistry in Chișinău',
    subtitle: 'Professional care for your smile since 2004',
    cta: 'Book Appointment',
    ctaSecondary: 'Our Services'
  },
  stats: {
    experience: '20+',
    experienceLabel: 'Years of Experience',
    patients: '5000+',
    patientsLabel: 'Happy Patients',
    specialists: '4',
    specialistsLabel: 'Qualified Specialists'
  },
  about: {
    title: 'About Our Clinic',
    description: 'Zimbet32 is a modern dental clinic that provides a full range of dental services. We use advanced technologies and materials to ensure the best results for our patients.',
    foundedYear: 'Year Founded',
    yearsExperience: 'Years of Experience',
    feature1Title: 'Experienced Specialists',
    feature1Desc: 'Doctors with international certificates and years of experience',
    feature2Title: 'Modern Equipment',
    feature2Desc: 'Latest technologies and materials for quality treatment',
    feature3Title: 'Individual Approach',
    feature3Desc: 'Personalized treatment plan for each patient',
    feature4Title: 'Painless Treatment',
    feature4Desc: 'Comfortable atmosphere and modern anesthesia',
    ctaButton: 'Book Appointment'
  },
  services: {
    title: 'Our Services',
    subtitle: 'Full range of dental services for the whole family',
    therapeutic: 'Therapeutic Dentistry',
    therapeuticDesc: 'Treatment of caries, pulpitis, periodontitis using modern materials and technologies',
    orthopedic: 'Orthopedic Dentistry',
    orthopedicDesc: 'Dental prosthetics, installation of crowns, veneers and bridge structures',
    surgery: 'Surgical Dentistry',
    surgeryDesc: 'Tooth extraction of any complexity, preparation for implantation',
    implantation: 'Dental Implantation',
    implantationDesc: 'Installation of dental implants using advanced technologies',
    orthodontics: 'Orthodontics',
    orthodonticsDesc: 'Bite correction, installation of braces and aligners',
    prevention: 'Prevention and Hygiene',
    preventionDesc: 'Professional teeth cleaning, fluoridation, fissure sealing',
    bookButton: 'Book Appointment'
  },
  servicePages: {
    breadcrumb: {
      home: 'Home',
      services: 'Services'
    },
    gallery: 'Work Gallery',
    whyUs: 'Why Choose Us',
    procedures: 'Procedures',
    bookAppointment: 'Book Appointment',
    therapeutic: {
      title: 'Therapeutic Dentistry',
      description: 'Therapeutic dentistry is the foundation of your dental health. Our specialists use modern techniques and materials to treat caries, pulpitis, periodontitis and other diseases. We use microscopic equipment for accurate diagnosis and quality root canal treatment.',
      procedure1: 'Caries Treatment',
      procedure1Desc: 'Removal of affected tissues and restoration with composite materials',
      procedure2: 'Pulpitis Treatment',
      procedure2Desc: 'Endodontic treatment using microscope',
      procedure3: 'Periodontitis Treatment',
      procedure3Desc: 'Comprehensive treatment of inflammation around tooth root',
      procedure4: 'Tooth Restoration',
      procedure4Desc: 'Restoring tooth form and function with modern materials',
      procedure5: 'Microscope Treatment',
      procedure5Desc: 'High-precision treatment with multiple magnification',
      procedure6: 'Root Canal Retreatment',
      procedure6Desc: 'Repeated endodontic treatment when necessary',
      benefit1: 'Painless Treatment',
      benefit1Desc: 'Modern anesthesia and comfortable atmosphere',
      benefit2: 'Quality Materials',
      benefit2Desc: 'We use only proven premium-class composites',
      benefit3: 'Result Guarantee',
      benefit3Desc: 'We provide warranty for all types of treatment'
    },
    orthopedic: {
      title: 'Orthopedic Dentistry',
      description: 'Orthopedic dentistry deals with restoring lost teeth and their functions. We offer all types of prosthetics: from single crowns to complete dentures. We use modern materials — ceramics, zirconium dioxide, metal-ceramics — to create aesthetic and durable structures.',
      procedure1: 'Ceramic Crowns',
      procedure1Desc: 'Aesthetic crowns made of pressed ceramics',
      procedure2: 'Zirconia Crowns',
      procedure2Desc: 'Strong and biocompatible structures',
      procedure3: 'Ceramic Veneers',
      procedure3Desc: 'Thin overlays for a perfect smile',
      procedure4: 'Bridge Prosthetics',
      procedure4Desc: 'Restoration of several missing teeth',
      procedure5: 'Removable Prosthetics',
      procedure5Desc: 'Partial and complete removable dentures',
      procedure6: 'Implant Prosthetics',
      procedure6Desc: 'Fixed structures on implants',
      benefit1: 'Individual Approach',
      benefit1Desc: 'Each structure is made according to individual impressions',
      benefit2: 'Own Dental Laboratory',
      benefit2Desc: 'Quality control at all stages of production',
      benefit3: 'Natural Aesthetics',
      benefit3Desc: 'Prosthetics indistinguishable from natural teeth'
    },
    surgery: {
      title: 'Surgical Dentistry',
      description: 'Surgical dentistry includes a wide range of operations — from simple tooth extraction to complex bone grafting procedures. Our surgeons have extensive experience in performing operations of any complexity. We use modern equipment and techniques to minimize trauma and accelerate healing.',
      procedure1: 'Tooth Extraction',
      procedure1Desc: 'Atraumatic extraction of teeth of any complexity',
      procedure2: 'Wisdom Tooth Removal',
      procedure2Desc: 'Safe removal of impacted and dystopic teeth',
      procedure3: 'Root Apex Resection',
      procedure3Desc: 'Tooth preservation with inflammation in root area',
      procedure4: 'Bone Grafting',
      procedure4Desc: 'Bone tissue augmentation for implantation',
      procedure5: 'Sinus Lift',
      procedure5Desc: 'Increasing bone volume in upper jaw',
      procedure6: 'Gum Plastic Surgery',
      procedure6Desc: 'Correction of gum level and contour',
      benefit1: 'Experienced Surgeons',
      benefit1Desc: 'Specialists with years of experience in complex operations',
      benefit2: 'Modern Equipment',
      benefit2Desc: 'Piezosurgery and other innovative technologies',
      benefit3: 'Fast Healing',
      benefit3Desc: 'Minimal trauma and short rehabilitation period'
    },
    implantation: {
      title: 'Dental Implantation',
      description: 'Dental implantation is a modern and reliable way to restore missing teeth. We use high-quality implants from leading manufacturers and advanced technologies to achieve long-lasting results. Our specialists have extensive experience in performing implantation of any complexity.',
      procedures: {
        single: {
          title: 'Single Implant',
          description: 'Placement of one implant to replace a missing tooth'
        },
        multiple: {
          title: 'Multiple Implants',
          description: 'Restoration of several teeth using implants'
        },
        allOn4: {
          title: 'All-on-4',
          description: 'Full jaw prosthetics on 4 implants'
        },
        bonePlasty: {
          title: 'Bone Grafting',
          description: 'Bone tissue augmentation for implant placement'
        },
        sinusLift: {
          title: 'Sinus Lift',
          description: 'Increasing bone volume in the upper jaw area'
        },
        immediate: {
          title: 'Immediate Implantation',
          description: 'Implant placement immediately after tooth extraction'
        }
      },
      benefits: {
        permanent: {
          title: 'Durability',
          description: 'Implants last for decades with proper care'
        },
        natural: {
          title: 'Natural Look',
          description: 'Implants look and function like natural teeth'
        },
        boneSaving: {
          title: 'Bone Preservation',
          description: 'Prevention of jaw bone atrophy'
        }
      },
      gallery: {
        surgery: 'Implantation procedure',
        crown: 'Crown placement on implant',
        allOn4: 'All-on-4 prosthetics',
        xray: 'Implant X-ray',
        boneGraft: 'Bone grafting',
        result: 'Implantation result'
      }
    },
    orthodontics: {
      title: 'Orthodontics',
      description: 'Orthodontic treatment helps correct bite and align teeth, creating a beautiful and healthy smile. We offer various correction systems — from classic braces to modern aligners. Our orthodontists will develop an individual treatment plan to achieve the best results.',
      procedures: {
        braces: {
          title: 'Metal Braces',
          description: 'Classic and effective bite correction system'
        },
        invisalign: {
          title: 'Invisalign',
          description: 'Clear removable aligners for discreet treatment'
        },
        lingual: {
          title: 'Lingual Braces',
          description: 'Braces installed on the inner side of teeth'
        },
        children: {
          title: 'Pediatric Orthodontics',
          description: 'Bite correction for children and teenagers'
        },
        retainers: {
          title: 'Retainers',
          description: 'Maintaining results after braces removal'
        },
        consultation: {
          title: 'Orthodontic Consultation',
          description: 'Diagnosis and treatment plan development'
        }
      },
      benefits: {
        beautiful: {
          title: 'Beautiful Smile',
          description: 'Straight teeth and proper bite improve appearance'
        },
        health: {
          title: 'Dental Health',
          description: 'Proper bite reduces risk of diseases'
        },
        confidence: {
          title: 'Confidence',
          description: 'Beautiful smile boosts self-esteem'
        }
      },
      gallery: {
        braces: 'Metal braces',
        invisalign: 'Invisalign aligners',
        beforeAfter: 'Before and after treatment',
        examination: 'Orthodontic examination',
        ceramic: 'Ceramic braces',
        result: 'Treatment result'
      }
    },
    prevention: {
      title: 'Prevention and Hygiene',
      description: 'Prevention is the foundation of healthy teeth and gums. Regular professional oral hygiene helps prevent cavities, gum disease, and other problems. We recommend preventive checkups and teeth cleaning every 6 months.',
      procedures: {
        cleaning: {
          title: 'Professional Cleaning',
          description: 'Removal of plaque and tartar with ultrasound'
        },
        whitening: {
          title: 'Teeth Whitening',
          description: 'Professional whitening for a bright white smile'
        },
        fluoride: {
          title: 'Fluoride Treatment',
          description: 'Enamel strengthening with fluoride preparations'
        },
        checkup: {
          title: 'Preventive Checkup',
          description: 'Regular diagnosis of teeth and gums condition'
        },
        sealants: {
          title: 'Fissure Sealing',
          description: 'Protection of chewing surfaces from cavities'
        },
        education: {
          title: 'Hygiene Education',
          description: 'Consultation on proper dental care'
        }
      },
      benefits: {
        savings: {
          title: 'Cost Savings',
          description: 'Prevention is cheaper than treating advanced diseases'
        },
        health: {
          title: 'Health',
          description: 'Prevention of serious problems development'
        },
        early: {
          title: 'Early Detection',
          description: 'Identifying problems at an early stage'
        }
      },
      gallery: {
        cleaning: 'Professional cleaning',
        whitening: 'Teeth whitening',
        fluoride: 'Fluoride treatment',
        checkup: 'Preventive checkup',
        sealant: 'Fissure sealing',
        result: 'Healthy teeth'
      }
    }
  },
  doctors: {
    title: 'Our Specialists',
    subtitle: 'Team of professionals with years of experience',
    experience: 'Experience',
    years: 'years'
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Book an appointment or ask a question',
    form: {
      name: 'Your Name',
      phone: 'Phone',
      email: 'Email',
      message: 'Message',
      submit: 'Submit Request',
      success: 'Thank you! We will contact you soon.',
      error: 'An error occurred. Please try again later.'
    },
    info: {
      address: 'Address',
      addressValue: 'MD-2012, Chișinău, str. București, 60',
      phone: 'Phone',
      phoneValue: '+373 22 123 456',
      email: 'Email',
      emailValue: 'info@zimbet32.md',
      hours: 'Working Hours',
      hoursValue: 'Mon-Fri: 9:00 - 19:00'
    }
  },
  footer: {
    description: 'Modern dental clinic with experienced specialists',
    quickLinks: 'Quick Links',
    contactInfo: 'Contact Information',
    copyright: ' Zimbet32. All rights reserved.'
  }
};